export default function detection (agent) {
  const comp_agent = agent.indexOf("whaletv") !== -1;
  if (comp_agent) {
    console.info ("[whaletv detection] detected");
  }
  return comp_agent;
}


// WEBPACK FOOTER //
// ./src/devices/zeasn/detection.js